import Resource from './resource';

export default service => {
  return Resource(service, {
    account_id: '',
    marker_id: '',
    type: 'image',
    image: {
      path: '',
      name: '',
      key: '',
      heading: 0
    },
    content: null
  });
};



// WEBPACK FOOTER //
// ./src/feathers/infographic-record.js